import React from "react";
import { Breadcrumbs, Typography, Link as MuiLink, Box } from "@mui/material";
import {
  ChatOutlined,
  DashboardOutlined,
  DateRangeOutlined,
  ForumOutlined,
  GroupsOutlined,
  PersonOutlineOutlined,
} from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";
import { colors } from "../../theme/theme";

const iconMap = {
  events: <DateRangeOutlined sx={{ mr: 0.5 }} fontSize="inherit" />,
  forum: <ForumOutlined sx={{ mr: 0.5 }} fontSize="inherit" />,
  groups: <GroupsOutlined sx={{ mr: 0.5 }} fontSize="inherit" />,
  messages: <ChatOutlined sx={{ mr: 0.5 }} fontSize="inherit" />,
  profile: <PersonOutlineOutlined sx={{ mr: 0.5 }} fontSize="inherit" />,
};

const CustomBreadcrumbs = () => {
  const location = useLocation();
  const rawPathnames = location.pathname
    .split("/")
    .filter((x) => x && x !== "dashboard");

  const pathnames = rawPathnames[0] === "profile" ? ["profile"] : rawPathnames;

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator={
        <Typography sx={{ color: colors.secondary, mx: 0.5 }}>/</Typography>
      }
    >
      <MuiLink
        component={Link}
        to="/dashboard"
        underline="hover"
        sx={{
          display: "flex",
          alignItems: "center",
          color: location.pathname === "/dashboard" ? "#fff" : colors.secondary,
        }}
      >
        <DashboardOutlined
          sx={{
            mr: 0.5,
            color:
              location.pathname === "/dashboard" ? "#fff" : colors.secondary,
          }}
          fontSize="inherit"
        />
        Home
      </MuiLink>

      {/* Dynamic path segments */}
      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;
        const icon = iconMap[value.toLowerCase()];

        if (pathnames[0] === "profile" && index > 0) {
          return null;
        }

        const routeName = value.includes("-")
          ? value
              .split("-")
              .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
              .join(" ")
          : value.charAt(0).toUpperCase() + value.slice(1);

        const content = (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {icon &&
              React.cloneElement(icon, {
                sx: { mr: 0.5, color: isLast ? "#fff" : colors.secondary },
                fontSize: "inherit",
              })}
            {routeName}
          </Box>
        );

        return isLast ? (
          <Typography component={"div"} key={to} sx={{ color: "#fff" }}>
            {content}
          </Typography>
        ) : (
          <MuiLink
            component={Link}
            to={to}
            underline="hover"
            key={to}
            sx={{ color: colors.secondary }}
          >
            {content}
          </MuiLink>
        );
      })}
    </Breadcrumbs>
  );
};

export default CustomBreadcrumbs;
